import React from "react";

interface LoaderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  /** Stable selector for QA automation. */
  testId?: string;
}

const Loader: React.FC<LoaderProps> = ({
  className = "",
  size = "md",
  testId = "loader",
}) => {
  const sizeClasses = {
    sm: "w-4 h-4 border-2",
    md: "w-8 h-8 border-2",
    lg: "w-12 h-12 border-4",
  };

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      role="status"
      aria-label="Loading"
      data-testid={testId}
      data-size={size}
    >
      <div
        data-testid={`${testId}-spinner`}
        className={`${sizeClasses[size]} border-ng-main border-t-transparent rounded-full animate-spin`}
      />
    </div>
  );
};

export default Loader;
